import React, { useState, useEffect } from 'react';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import api from '../FetchComponents/FetchComponentsServices';
import { Loader } from "@progress/kendo-react-indicators";
import { filterBy } from "@progress/kendo-data-query";
import XrefModal from './XrefModal'
import XrefDeleteModal from './XrefDeleteModal'
import "../Shared/Xref.css"

const initialDataState = {
    skip: 0,
    take: 15,
};

const initialFilter = {
    logic: "and",
    filters: [
    ],
};


const Xref = ({ autoCompleteData, refetchAutocomplete }) => {
    const [Loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [dataLength, setDataLength] = useState(0);
    const [page, setPage] = useState(initialDataState);
    const [pageSizeValue, setPageSizeValue] = useState();
    const [error, setError] = useState(false);
    const [filter, setFilter] = useState(initialFilter);
    const [xref, setXref] = useState({});
    const [showAddModal, setShowAddModal] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [userName, setUserName] = useState('');
    const [response, setResponse] = useState('');
    const [message, setMessage] = useState('');

    const EditButtons = (props) => {
        return (
            <td>
                <button style={{ marginRight: '10px' }} onClick={() => {
                    setXref(props.dataItem)
                    if (props.dataItem.WorkForceIDNum && autoCompleteData) {
                        const autcompleteRecord = autoCompleteData.find(data => data.o === props.dataItem.WorkForceIDNum)
                        if (autcompleteRecord && autcompleteRecord.n) {
                            setUserName(autcompleteRecord.n)
                        }
                    }
                    setShowUpdateModal(true)
                }}>Edit</button>
                <button onClick={() => {
                    setXref(props.dataItem)
                    if (props.dataItem.WorkForceIDNum && autoCompleteData) {
                        const autcompleteRecord = autoCompleteData.find(data => data.o === props.dataItem.WorkForceIDNum)
                        if (autcompleteRecord && autcompleteRecord.n) {
                            setUserName(autcompleteRecord.n)
                        }
                    }
                    setShowDeleteModal(true)
                }}>Delete</button>
            </td>
        );
    };

    const UpdateXref = async (updatedXref) => {
        if (!hasRequiredFields(updatedXref)) {
            setResponse(`Unable to update record: WorkForceIDNum and MatrixPersonID are required`)
        } else {
            try {
                const result = await api.updateXrefData(updatedXref)
                if (result === 'success') {
                    setResponse('Successfuly updated record')
                    refreshPage()
                } else {
                    setResponse(`Unable to update record: ${result}`)
                }
            } catch (ex) {
                setResponse(`Unable to update record: ${ex}`)
            }
        }
    }

    const AddXref = async (newXref) => {
        if (!hasRequiredFields(newXref)) {
            setResponse(`Unable to add record: WorkForceIDNum and MatrixPersonID are required`)
        }
        else if (data.find((record) => record.MatrixPersonID === newXref.MatrixPersonID)) {
            setResponse(`Unable to add record: This record already exists`)
        }
        else {
            try {
                const result = await api.addXrefData(newXref)
                if (result === 'success') {
                    setResponse('Successfuly added record')
                    refreshPage()
                } else {
                    setResponse(`Unable to add record: ${result}`)
                }
            } catch (ex) {
                setResponse(`Unable to add record: ${ex}`)
            }
        }
    }

    const DeleteXref = async (xref) => {
        try {
            const result = await api.deleteXrefData(xref)
            if (result === 'success') {
                setResponse('Successfuly deleted record')
                refreshPage()
            } else {
                setResponse(`Unable to delete record: ${result}`)
            }
        } catch (ex) {
            setResponse(`Unable to delete record: ${ex}`)
        }
    }

    const hasRequiredFields = (xref) => {
        return xref.WorkForceIDNum && xref.MatrixPersonID
    }

    const closeModal = () => {
        setXref({})
        setUserName('')
        setResponse('')
        setShowAddModal(false)
        setShowDeleteModal(false)
        setShowUpdateModal(false)
    }

    const refreshPage = () => {
        refetchAutocomplete()
        fetchData()
    }

    const pageChange = (event) => {
        const targetEvent = event.nativeEvent ? event.nativeEvent : event.target;
        const take =
            targetEvent.value === "All" ? data.length : event.page.take;
        if (targetEvent.value) {
            setPageSizeValue(targetEvent.value);
        }
        setPage({
            ...event.page,
            take,
        });
    };

    const fetchData = async () => {
        try {
            const result = await api.getXrefData()
            setData(result);
            setDataLength(result.length)
            setLoading(false)
        } catch (e) {
            setError(true);
            setMessage(e.message);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        setPage({ ...page, 'skip': 0 })
        setDataLength(filterBy(data, filter).length)
    }, [filter]);
    return (
        <>
            <h1 className="page-title">Xref Data</h1>

            {error && <h2>{message}</h2>}

            {!error && showUpdateModal && (
                <XrefModal
                    Xref={xref}
                    mode="Update"
                    userName={userName}
                    isOpen={showUpdateModal}
                    onClose={closeModal}
                    onSave={UpdateXref}
                    response={response}
                />
            )}

            {!error && showAddModal && (
                <XrefModal
                    Xref={{ WorkForceIDNum: "", MatrixPersonID: "", MatrixBadgeID: "" }}
                    mode="Add"
                    userName="Create New Xref"
                    isOpen={showAddModal}
                    onClose={closeModal}
                    onSave={AddXref}
                    response={response}
                />
            )}

            {!error && showDeleteModal && (
                <XrefDeleteModal
                    Xref={xref}
                    userName={userName}
                    isOpen={showDeleteModal}
                    onClose={closeModal}
                    onSave={DeleteXref}
                    response={response}
                />
            )}

            {Loading && (
                <h2>
                    <Loader className="spinner-small" size="small" type="infinite-spinner" />
                    <em> Loading Data...</em>
                </h2>
            )}

            {!error && dataLength > 0 && (
                <>
                    <h2>{dataLength} records found</h2>

                    <div className="add-xref-btn-container">
                        <button
                            className="k-button-solid-secondary k-button-lg"
                            onClick={() => setShowAddModal(true)}
                        >
                            Add Record
                        </button>
                    </div>

                    <Grid
                        style={{ height: "600px" }}
                        data={filterBy(data, filter).slice(page.skip, page.take + page.skip)}
                        filterable={true}
                        filter={filter}
                        onFilterChange={(e) => setFilter(e.filter)}
                        skip={page.skip}
                        take={page.take}
                        total={dataLength}
                        pageable={{
                            buttonCount: 4,
                            pageSizes: [5, 15, 25],
                            pageSizeValue: pageSizeValue,
                        }}
                        onPageChange={pageChange}
                    >
                        <GridColumn field="MatrixPersonID" title="Matrix Person ID" filter="text" />
                        <GridColumn field="WorkForceIDNum" title="Workforce ID Number" filter="text" />
                        <GridColumn field="MatrixBadgeID" title="Matrix Badge ID" filter="text" />
                        <GridColumn
                            style={{ textAlign: "center" }}
                            width="200px"
                            field=""
                            title="Modify"
                            cell={EditButtons}
                            filterable={false}
                        />
                    </Grid>
                </>
            )}
        </>
    );

}
export default Xref;